import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { AdministradorService } from 'src/app/services/administrador.service';
import { RedimirSupervisor } from 'src/app/models/redimir.interface';
@Component({
    selector: 'app-redimir-supervisor-atender',
    templateUrl: './redimir-supervisor-atender.component.html',
    styleUrls: ['./redimir-supervisor-atender.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class RedimirSupervisorAtenderComponent {
    idRedimir!: string;
    redeemForm: FormGroup;
    redimir!: RedimirSupervisor;
    archivoSeleccionado: File | null = null;
    showModal = false;
    modalTitle = '';
    modalMessage = '';
    accionPendiente: 'salir' | 'cancelar' | 'rechazar' | null = null;

    get redimirFrm() {
        return this.redeemForm.controls;
    }
    get cantidad(): number {
        return this.redimir.casosclinicos.reduce((accumulator, item) => accumulator + item.e_puntos, 0);
    }
    constructor(
        private authService: AuthService,
        private activedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private location: Location,
        private administradorService: AdministradorService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {
        this.idRedimir = this.activedRoute.snapshot.params['id'];
        this.redeemForm = this.createFormRedimir();
        this.obtenerInformacion(this.idRedimir);
    }

    ngOnInit(): void { }

    obtenerInformacion(id: string): void {
        this.administradorService.getRedimirSupervisorAtender(id)
            .subscribe({
                next: (resp) => {
                    this.redimir = resp.datos;
                    this.fullRedimirForm(resp.datos);
                    this.showSuccess(resp.mensaje);
                },
                error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
            })
    }

    createFormRedimir(): FormGroup {
        return this.fb.group({
            cantidad: ['', [Validators.required, Validators.min(0)]],
            fechaFinal: ['', Validators.required],
            observacion: ['', Validators.required]
        });
    }

    rechazardoCanje(): void {
        if (this.redeemForm.valid) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('fechaFinal', this.redeemForm.get('fechaFinal')?.value);
            formData.append('observacion', this.redeemForm.get('observacion')?.value);
            this.administradorService
                .setRedimirSupervisorRechazar(formData)
                .subscribe({
                    next: (resp) => {
                        this.showSuccess(resp.mensaje);
                        this.location.back();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err.error.message);
                    }
                })
        }
    }

    cancelarCanje(): void {
        if (this.redeemForm.valid) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('fechaFinal', this.redeemForm.get('fechaFinal')?.value);
            formData.append('observacion', this.redeemForm.get('observacion')?.value);
            this.administradorService
                .setRedimirSupervisorCancelar(formData)
                .subscribe({
                    next: (resp) => {
                        this.showSuccess(resp.mensaje);
                        this.location.back();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err.error.message);
                    }
                })
        } else {
            this.showError('Por favor, complete el formulario correctamente');
        }
    }

    fullRedimirForm(redimir: RedimirSupervisor): void {
        this.redimirFrm['cantidad'].setValue(redimir.redimir);
        this.redimirFrm['observacion'].setValue(redimir.observacion);
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];
        if (file) {
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.showError('El archivo es demasiado grande. El tamaño máximo permitido es 5MB.');
                event.target.value = '';
                this.archivoSeleccionado = null;
                return;
            }
            this.archivoSeleccionado = file;
        }
    }

    onExit(): void {
        this.accionPendiente = 'salir';
        this.modalTitle = 'Confirmar salir';
        this.modalMessage = '¿Está seguro que desea Salir?';
        this.showModal = true;
    }

    onCancel(): void {
        if (this.formTieneContenido()) {
            this.accionPendiente = 'cancelar';
            this.modalTitle = 'Confirmar Cancelación';
            this.modalMessage = '¿Está seguro que desea cancelar?';
            this.showModal = true;
        } else {
            this.showError('Por favor, complete el formulario correctamente');
        }
    }

    onReject(): void {
        if (this.formTieneContenido()) {
            this.accionPendiente = 'rechazar';
            this.modalTitle = 'Confirmar Rechazo';
            this.modalMessage = '¿Está seguro que desea rechazar este canje?';
            this.showModal = true;
        } else {
            this.showError('Por favor, complete el formulario correctamente');
        }
    }

    onSubmit(): void {
        if (this.redeemForm.valid && this.archivoSeleccionado) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('redimir', this.redeemForm.get('cantidad')?.value);
            formData.append('fechaFinal', this.redeemForm.get('fechaFinal')?.value);
            formData.append('observacion', this.redeemForm.get('observacion')?.value);
            formData.append('documento', this.archivoSeleccionado);

            // Aquí puedes agregar la lógica para enviar el formData al servidor

            console.log('formulario..', formData.get('fk_redimir'), formData.get('redimir'), formData.get('fechaFinal'), formData.get('observacion'), formData.get('documento'));
            //  console.log('Formulario válido, enviando datos al servidor...', this.idRedimir, this.redeemForm.get('cantidad')?.value);

            this.administradorService
                .setRedimirSupervisorAceptar(formData)
                .subscribe({
                    next: (resp) => {
                        console.log(resp);
                        this.showSuccess(resp.mensaje);
                        this.location.back();
                    },
                    error: (err: HttpErrorResponse) => { console.log(err.error.message) }
                })


        } else {
            this.showError('Por favor, complete el formulario correctamente y seleccione un archivo.');
        }
    }

    confirmarAccion(): void {
        if (this.accionPendiente === 'salir') {
            this.location.back();
        } else if (this.accionPendiente === 'rechazar') {
            console.log('Formulario rechazado');
            this.rechazardoCanje();
        } else if (this.accionPendiente === 'cancelar') {
            console.log('Formulario cancelado');
            this.cancelarCanje();
        }
        this.closeModal();
    }

    cancelarAccion(): void {
        this.closeModal();
    }

    closeModal(): void {
        this.showModal = false;
        this.accionPendiente = null;
    }

    resetForm(): void {
        this.redeemForm.reset();
        this.archivoSeleccionado = null;
    }

    formTieneContenido(): boolean {
        return !this.redeemForm.pristine || this.archivoSeleccionado !== null;
    }

    showSuccess(mensaje: string): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: mensaje
        });
    }

    showError(mensaje: string): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: mensaje
        });
    }
}